<p-tabView (onChange)="onTabChange($event)" [ngClass]="{'gltab': visibleFromModule != 'Finance'}">
    <p-tabPanel header="Overview">
        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12 p-md-4">
                <div class="p-fluid">
                    <div class="card" style="min-height: 160px;">
                        <h6 class="p-mb-0">Vendor Information</h6>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_billaddress  && poTemplate.labels_billaddress[0].isChecked">
                            {{poDetails?.vendor?.vendorName}}</p>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_billaddress  && poTemplate.labels_billaddress[1].isChecked">
                            {{ordersVendorAddr}}<span *ngIf="ordersVendorAddr !== ''">,</span></p>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_billaddress  && poTemplate.labels_billaddress[2].isChecked">
                            {{ordersVendorCity}}<span *ngIf="ordersVendorCity !== ''">, </span>
                            {{ordersVendorState}}<span *ngIf="ordersVendorState !== ''">, </span>
                            {{ordersVendorCountry}}<span *ngIf="ordersVendorCountry !== ''">, </span>
                            {{ordersVendorZipcode}}
                        </p>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_billaddress  && poTemplate.labels_billaddress[3].isChecked">
                            {{poDetails?.contact?.firstName}}{{' '}}{{poDetails?.contact?.lastName}}</p>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_billaddress  && poTemplate.labels_billaddress[4].isChecked">
                            {{poDetails?.contact?.contactPhones?.length &&
                            poDetails?.contact?.contactPhones[0]?.phone?.number}}</p>
                        <!-- Custom -->
                        <ng-container *ngFor="let field of purchase_billing; let i=index;">
                            <ng-container [ngSwitch]="field.formControl.name">
                                <ng-container *ngSwitchCase="'InputBox'">
                                    <p class="p-mb-0">{{field.name}} <span>{{field.value}}</span></p>
                                </ng-container>
                                <ng-container *ngSwitchCase="'DropDownList'">
                                    <p class="p-mb-0">{{field.name}} <span>{{field?.value?.name}}</span></p>
                                </ng-container>
                                <ng-container *ngSwitchCase="'MultipleDropDownList'">
                                    <p class="p-mb-0">{{field.name}} <span>{{field?.value?.name}}</span></p>
                                </ng-container>
                                <ng-container *ngSwitchCase="'CheckBox'">
                                    <p>{{field.name}} <span>{{field?.value && field?.value.length >0? field?.value[0]:
                                            ""}}</span></p>
                                </ng-container>
                                <ng-container *ngSwitchCase="'FileUpload'">
                                    <div *ngIf="field.customUploadedFiles && field.customUploadedFiles?.length> 0">
                                        <p class="p-mb-0" *ngFor="let pic of field.customUploadedFiles">
                                            {{field.name}}: <span>{{pic?.name}}</span>
                                        </p>
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'Picture'">
                                    <div *ngIf="field.customUploadedFiles && field.customUploadedFiles?.length> 0">
                                        <p class="p-mb-0" *ngFor="let pic of field.customUploadedFiles">
                                            {{field.name}}: <span>{{pic?.name}}</span>
                                        </p>
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'RadioButton'">
                                    <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                                </ng-container>
                                <ng-container *ngSwitchCase="'Rating'">
                                    <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                                </ng-container>
                                <ng-container *ngSwitchCase="'ToggleButton'">
                                    <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                                </ng-container>
                                <ng-container *ngSwitchCase="'DatePicker'">
                                    <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="p-col-12 p-md-4">
                <div class="p-fluid">
                    <div class="card" style="min-height: 160px;">
                        <h6 class="p-mb-0">Shipping</h6>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_shipaddress  && poTemplate.labels_shipaddress[0].isChecked">
                            {{app?.user?.organizationName}}</p>
                        <p class="p-mb-0">{{poDetails?.warehouse?.name}}</p>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_shipaddress  && poTemplate.labels_shipaddress[1].isChecked">
                            {{poDetails?.warehouse?.address?.streetAddress1 ?
                            poDetails?.warehouse?.address?.streetAddress1 :
                            (poDetails?.warehouse?.address?.streetAddress2 ?
                            poDetails?.warehouse?.address?.streetAddress2 : null)}} <span
                                *ngIf="poDetails?.warehouse?.address?.city && (poDetails?.warehouse?.address?.streetAddress1 || poDetails?.warehouse?.address?.streetAddress2)">,</span>
                        </p>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_shipaddress  && poTemplate.labels_shipaddress[2].isChecked">
                            {{poDetails?.warehouse?.address?.city ? poDetails?.warehouse?.address?.city?.name :
                            null}}<span *ngIf="poDetails?.warehouse?.address?.state">,</span>
                            {{poDetails?.warehouse?.address?.state ? poDetails?.warehouse?.address?.state?.name :
                            null}}<span *ngIf="poDetails?.warehouse?.address?.country">,</span>
                            {{shipAdsavedOrder?.warehousedress?.address?.country ?
                            poDetails?.warehouse?.address?.country?.name : null}}<span
                                *ngIf="poDetails?.warehouse?.address?.zipCode">,</span>
                            {{poDetails?.warehouse?.address?.zipCode ? poDetails?.warehouse?.address?.zipCode :
                            null}}
                        </p>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_shipaddress  && poTemplate.labels_shipaddress[3].isChecked">
                            {{app?.user?.userName}}</p>
                        <p class="p-mb-0"></p>
                        <p class="p-mb-0"></p>
                        <!-- Custom -->
                        <ng-container *ngFor="let field of purchase_shipping; let i=index;">
                            <ng-container [ngSwitch]="field.formControl.name">
                                <ng-container *ngSwitchCase="'InputBox'">
                                    <p class="p-mb-0">{{field.name}} <span>{{field.value}}</span></p>
                                </ng-container>
                                <ng-container *ngSwitchCase="'DropDownList'">
                                    <p class="p-mb-0">{{field.name}} <span>{{field?.value?.name}}</span></p>
                                </ng-container>
                                <ng-container *ngSwitchCase="'MultipleDropDownList'">
                                    <p class="p-mb-0">{{field.name}} <span>{{field?.value?.name}}</span></p>
                                </ng-container>
                                <ng-container *ngSwitchCase="'CheckBox'">
                                    <p>{{field.name}} <span>{{field?.value && field?.value.length >0? field?.value[0]:
                                            ""}}</span></p>
                                </ng-container>
                                <ng-container *ngSwitchCase="'FileUpload'">
                                    <div *ngIf="field.customUploadedFiles && field.customUploadedFiles?.length> 0">
                                        <p class="p-mb-0" *ngFor="let pic of field.customUploadedFiles">
                                            {{field.name}}: <span>{{pic?.name}}</span>
                                        </p>
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'Picture'">
                                    <div *ngIf="field.customUploadedFiles && field.customUploadedFiles?.length> 0">
                                        <p class="p-mb-0" *ngFor="let pic of field.customUploadedFiles">
                                            {{field.name}}: <span>{{pic?.name}}</span>
                                        </p>
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'RadioButton'">
                                    <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                                </ng-container>
                                <ng-container *ngSwitchCase="'Rating'">
                                    <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                                </ng-container>
                                <ng-container *ngSwitchCase="'ToggleButton'">
                                    <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                                </ng-container>
                                <ng-container *ngSwitchCase="'DatePicker'">
                                    <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="p-col-12 p-md-4">
                <div class="p-fluid">
                    <div class="card" style="min-height: 160px;">
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_misc  && poTemplate.labels_misc[0].isChecked">
                            {{poTemplate && poTemplate.labels_misc && poTemplate.labels_misc[0].labelname}}:
                            {{poDetails?.poDate | localDate:'MM/DD/YYYY'}}
                        </p>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_misc  && poTemplate.labels_misc[1].isChecked">
                            {{poTemplate && poTemplate.labels_misc && poTemplate.labels_misc[1].labelname}}.:
                            {{poDetails?.number}}
                        </p>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_misc  && poTemplate.labels_misc[2].isChecked">
                            {{poTemplate && poTemplate.labels_misc && poTemplate.labels_misc[2].labelname}}:
                            {{poDetails?.purchaseOrderStage}}
                        </p>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_misc  && poTemplate.labels_misc[3].isChecked">
                            {{poTemplate && poTemplate.labels_misc && poTemplate.labels_misc[3].labelname}}:
                            {{poDetails?.purchaseOrderStatus}}
                        </p>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_misc  && poTemplate.labels_misc[4].isChecked">
                            {{poTemplate && poTemplate.labels_misc && poTemplate.labels_misc[4].labelname}}:
                            {{poDetails?.createdByUser}}</p>
                        <p class="p-mb-0"
                            *ngIf="poTemplate && poTemplate.labels_misc  && poTemplate.labels_misc[5].isChecked">
                            {{poTemplate && poTemplate.labels_misc && poTemplate.labels_misc[5].labelname}}.:
                            {{poDetails?.referenceNumber}}
                        </p>
                        <p class="p-mb-0" *ngIf="poDetails && (baseCurrency?.currencyId!==poDetails?.currencyUnitId)">
                            Currency: 1 {{baseCurrency?.code}}
                            = {{poDetails?.exchangeRate}}
                            {{poDetails?.currencyUnit?.code}}
                        </p>

                        <!-- Custom -->
                        <ng-container *ngFor="let field of purchase_misc; let i=index;">
                            <ng-container [ngSwitch]="field.formControl.name">
                                <ng-container *ngSwitchCase="'InputBox'">
                                    <p class="p-mb-0">{{field.name}} <span>{{field.value}}</span></p>
                                </ng-container>
                                <ng-container *ngSwitchCase="'DropDownList'">
                                    <p class="p-mb-0">{{field.name}} <span>{{field?.value?.name}}</span></p>
                                </ng-container>
                                <ng-container *ngSwitchCase="'MultipleDropDownList'">
                                    <p class="p-mb-0">{{field.name}} <span>{{field?.value?.name}}</span></p>
                                </ng-container>
                                <ng-container *ngSwitchCase="'CheckBox'">
                                    <p>{{field.name}} <span>{{field?.value && field?.value.length >0? field?.value[0]:
                                            ""}}</span></p>
                                </ng-container>
                                <ng-container *ngSwitchCase="'FileUpload'">
                                    <div *ngIf="field.customUploadedFiles && field.customUploadedFile?.length> 0">
                                        <p class="p-mb-0" *ngFor="let pic of field.customUploadedFiles">
                                            {{field.name}}: <span>{{pic?.name}}</span>
                                        </p>
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'Picture'">
                                    <div *ngIf="field.customUploadedFiles && field.customUploadedFile?.length> 0">
                                        <p class="p-mb-0" *ngFor="let pic of field.customUploadedFiles">
                                            {{field.name}}: <span>{{pic?.name}}</span>
                                        </p>
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'RadioButton'">
                                    <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                                </ng-container>
                                <ng-container *ngSwitchCase="'Rating'">
                                    <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                                </ng-container>
                                <ng-container *ngSwitchCase="'ToggleButton'">
                                    <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                                </ng-container>
                                <ng-container *ngSwitchCase="'DatePicker'">
                                    <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-field p-formgrid p-grid" *ngIf="poTemplate?.labels_section?.length>0">
            <div class="p-col" *ngIf="poTemplate.labels_section[0].isChecked">
                <div class="card">
                    <h6 class="p-mb-0">{{poTemplate.labels_section[0].labelname}}</h6>
                    <p class="p-mb-0">
                        {{poDetails?.paymentTerm?.name}}
                    </p>
                </div>
            </div>
            <div class="p-col" *ngIf="poTemplate.labels_section[1].isChecked">
                <div class="card">
                    <h6 class="p-mb-0">{{poTemplate.labels_section[1].labelname}}</h6>
                    <p class="p-mb-0">
                        {{poDetails?.paymentMethod?.name}}
                    </p>
                </div>
            </div>
            <div class="p-col" *ngIf="poTemplate.labels_section[2].isChecked">
                <div class="card">
                    <h6 class="p-mb-0">{{poTemplate.labels_section[2].labelname}}</h6>
                    <p class="p-mb-0">
                        {{poDetails?.shippingTerm?.name}}
                    </p>
                </div>
            </div>
            <div class="p-col" *ngIf="poTemplate.labels_section[3].isChecked">
                <div class="card">
                    <h6 class="p-mb-0">{{poTemplate.labels_section[3].labelname}}</h6>
                    <p class="p-mb-0">
                        {{poDetails?.shippingMethod?.name}}
                    </p>
                </div>
            </div>
            <div class="p-col" *ngIf="poTemplate.labels_section[4].isChecked">
                <div class="card">
                    <h6 class="p-mb-0">{{poTemplate.labels_section[4].labelname}}</h6>
                    <p class="p-mb-0">
                        {{poDetails?.user?.firstName}} {{poDetails?.user?.lastName}}
                    </p>
                </div>
            </div>
            <div class="p-col" *ngIf="purchase_section.length>0">
                <div class="card">
                    <!-- Custom -->
                    <ng-container *ngFor="let field of purchase_section; let i=index;">
                        <ng-container [ngSwitch]="field.formControl.name">
                            <ng-container *ngSwitchCase="'InputBox'">
                                <p class="p-mb-0">{{field.name}} <span>{{field.value}}</span></p>
                            </ng-container>
                            <ng-container *ngSwitchCase="'DropDownList'">
                                <p class="p-mb-0">{{field.name}} <span>{{field?.value?.name}}</span></p>
                            </ng-container>
                            <ng-container *ngSwitchCase="'MultipleDropDownList'">
                                <p class="p-mb-0">{{field.name}} <span>{{field?.value?.name}}</span></p>
                            </ng-container>
                            <ng-container *ngSwitchCase="'CheckBox'">
                                <p>{{field.name}} <span>{{field?.value && field?.value.length >0? field?.value[0]:
                                        ""}}</span></p>
                            </ng-container>
                            <ng-container *ngSwitchCase="'FileUpload'">
                                <div *ngIf="field.customUploadedFiles && field.customUploadedFiles?.length> 0">
                                    <p class="p-mb-0" *ngFor="let pic of field.customUploadedFiles">
                                        {{field.name}}: <span>{{pic?.name}}</span>
                                    </p>
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Picture'">
                                <div *ngIf="field.customUploadedFiles && field.customUploadedFiles?.length> 0">
                                    <p class="p-mb-0" *ngFor="let pic of field.customUploadedFiles">
                                        {{field.name}}: <span>{{pic?.name}}</span>
                                    </p>
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'RadioButton'">
                                <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Rating'">
                                <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                            </ng-container>
                            <ng-container *ngSwitchCase="'ToggleButton'">
                                <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                            </ng-container>
                            <ng-container *ngSwitchCase="'DatePicker'">
                                <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </div>

            </div>
        </div>
        <!-- <div class="p-field p-formgrid p-grid"
            *ngIf="poDetails?.purchaseOrderStageId == 1 || poDetails?.purchaseOrderStageId == 2 || poDetails?.purchaseOrderStageId == 3"> -->
        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12">
                <p-table [value]="purchaseListTB" styleClass="p-datatable-gridlines p-datatable-striped">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Item</th>
                            <th style="width: 400px;">Description</th>
                            <th>Ord. Qty</th>
                            <th>Qty Pending</th>
                            <th>Qty Rec.</th>
                            <th>UOM</th>
                            <th *ngIf="poTemplate && poTemplate.labels_table  && poTemplate.labels_table[6].isChecked">
                                Discount</th>
                            <th>Rate</th>
                            <th *ngIf="poTemplate && poTemplate.labels_table  && poTemplate.labels_table[8].isChecked">
                                {{poTemplate?.labels_table[8]?.labelname}}</th>
                            <th *ngIf="poTemplate && poTemplate.labels_table  && poTemplate.labels_table[5].isChecked">
                                {{poTemplate?.labels_table[5]?.labelname}}</th>
                            <th *ngIf="poTemplate && poTemplate.labels_table  && poTemplate.labels_table[7].isChecked">
                                {{poTemplate?.labels_table[7]?.labelname}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product let-index="rowIndex">
                        <tr>
                            <td>
                                {{product?.itemNo ? product?.itemNo : null}}
                            </td>
                            <td>
                                {{product?.description ? (product?.description | shorten: 55) : null}}
                            </td>
                            <td>
                                {{product?.quantity | customNumberFormat: qtyDecimal}}
                            </td>
                            <td>
                                <span *ngIf="product?.typeId!=4">{{product?.quantityPending | customNumberFormat:
                                    qtyDecimal}}</span>
                            </td>
                            <td>
                                <span *ngIf="product?.typeId!=4">{{product?.quantityReceived | customNumberFormat:
                                    qtyDecimal}}</span>
                            </td>
                            <td>
                                <span *ngIf="product?.typeId!=4">{{product?.uom ?? null}}</span>
                            </td>
                            <td *ngIf="poTemplate && poTemplate.labels_table  && poTemplate.labels_table[6].isChecked">
                                <span
                                    *ngIf="product?.discountType =='$' && product?.typeId !=4">{{product?.discountAmount
                                    |customNumberFormat: length | currencySymbol}}</span>
                                <span
                                    *ngIf="product?.discountType !='$' && product?.typeId !=4">{{product?.discountAmount
                                    |customNumberFormat: length}}</span>
                                <span *ngIf="product?.discountType=='%' && product?.typeId!=4">%</span>
                            </td>
                            <td>
                                <span *ngIf="product?.typeId!=4">{{poDetails?.currencyUnit?.symbol}}
                                    {{product?.pricePerProduct |customNumberFormat: length }}</span>
                            </td>
                            <td>
                                {{poDetails?.currencyUnit?.symbol}} {{product?.totalAmount |customNumberFormat: length
                                }}
                            </td>
                            <td *ngIf="poTemplate && poTemplate.labels_table  && poTemplate.labels_table[5]?.isChecked">
                                {{poDetails?.currencyUnit?.symbol}} {{product.taxAmount |
                                customNumberFormat: length}}
                            </td>
                            <td *ngIf="product.typeId!=4">
                                {{poDetails?.currencyUnit?.symbol}}
                                {{product.netAmount ? (product.netAmount
                                |
                                customNumberFormat: length) : null}}
                            </td>
                        </tr>

                        <!-- bundle items -->
                        <tr *ngFor="let bundle of product?.products;let i = index" class="bundleRow">
                            <td>
                                {{bundle?.itemNo ? bundle?.itemNo : null}}
                            </td>
                            <td>
                                {{bundle?.description?.length > 55 ? (bundle?.description | slice: 0:55) + "...":
                                bundle?.description}}
                            </td>
                            <td>
                                {{bundle?.availabel}}
                            </td>
                            <td>
                                {{bundle?.quantityPending}}
                            </td>
                            <td>
                                {{bundle?.quantityReceived}}
                            </td>
                            <td>
                                {{bundle?.uom ? bundle?.uom : null}}
                            </td>
                            <td *ngIf="poTemplate && poTemplate.labels_table  && poTemplate.labels_table[5].isChecked">
                                {{bundle?.tax}}
                            </td>
                            <td *ngIf="poTemplate && poTemplate.labels_table  && poTemplate.labels_table[6].isChecked">
                                <span *ngIf="bundle?.discountType =='$'">{{bundle?.discountAmount |customNumberFormat:
                                    length | currencySymbol}}</span>
                                <span *ngIf="bundle?.discountType !='$'">{{bundle?.discountAmount |customNumberFormat:
                                    length}}</span>
                                <span *ngIf="bundle?.discountType =='%'">%</span>
                            </td>
                            <td>
                                {{bundle?.pricePerProduct |customNumberFormat: length | currencySymbol}}
                            </td>
                            <td>
                                {{bundle?.totalAmount |customNumberFormat: length | currencySymbol}}
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="footer">
                        <tr>
                            <td>Total</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>{{poDetails?.currencyUnit?.symbol}} {{poDetails?.totalAmount
                                |customNumberFormat: length }}</td>
                            <td *ngIf="!footerTaxEnabled">
                                {{poDetails?.currencyUnit?.symbol}} {{poDetails?.taxAmount | customNumberFormat: length }}
                            </td>
                            <td>{{poDetails?.currencyUnit?.symbol}} {{lineTotal | customNumberFormat: length }}</td>
                        </tr>
                        <tr>
                            <td [attr.colspan]="poTemplate?.labels_table[5]?.isChecked ? 9 : 8" class="p-text-right">
                                Shipping</td>
                            <td colspan="2">{{poDetails?.currencyUnit?.symbol}} {{poDetails?.shippingAmount
                                |customNumberFormat: length }}</td>
                        </tr>
                        <tr *ngIf="footerTaxEnabled">
                            <td [attr.colspan]="poTemplate?.labels_table[5]?.isChecked ? 9 : 8" class="p-text-right">Tax
                            </td>
                            <td colspan="2">{{poDetails?.currencyUnit?.symbol}} {{poDetails?.taxAmount |customNumberFormat: length }}</td>
                        </tr>
                        <tr *ngIf="poTemplate?.labels_footer[3]?.isChecked">
                            <td [attr.colspan]="poTemplate?.labels_table[5]?.isChecked ? 9 : 8" class="p-text-right">
                                Discount</td>
                            <td colspan="2">{{poDetails?.currencyUnit?.symbol}} {{poDetails?.discountAmount
                                |customNumberFormat: length }}</td>
                        </tr>
                        <tr>
                            <td [attr.colspan]="poTemplate?.labels_table[5]?.isChecked ? 9 : 8" class="p-text-right">
                                Order total</td>
                            <td colspan="2">{{poDetails?.currencyUnit?.symbol}} {{poDetails?.netAmount
                                |customNumberFormat: length }}</td>
                        </tr>
                    </ng-template>
                    `
                </p-table>
            </div>
        </div>

        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12">
                <p>Vendor message: {{poDetails?.purchaseOrderAudits.length>0 ?
                    poDetails?.purchaseOrderAudits[(poDetails?.purchaseOrderAudits.length-1)].note.comment:''}}
                </p>
            </div>
            <div class="p-col-12">
                <p>Memo: {{poDetails?.purchaseOrderNotes.length>0 ?
                    poDetails?.purchaseOrderNotes[(poDetails?.purchaseOrderNotes.length-1)].note.comment: ''}}
                </p>
            </div>

            <!-- Custom -->
            <ng-container *ngFor="let field of purchase_message; let i=index;">
                <ng-container [ngSwitch]="field.formControl.name">
                    <ng-container *ngSwitchCase="'InputBox'">
                        <p class="p-mb-0">{{field.name}} <span>{{field.value}}</span></p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'DropDownList'">
                        <p class="p-mb-0">{{field.name}} <span>{{field?.value?.name}}</span></p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'MultipleDropDownList'">
                        <p class="p-mb-0">{{field.name}} <span>{{field?.value?.name}}</span></p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'CheckBox'">
                        <p>{{field.name}} <span>{{field?.value && field?.value.length >0? field?.value[0]:
                                ""}}</span></p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'FileUpload'">
                        <div *ngIf="field?.customUploadedFiles?.length > 0">
                            <p class="p-mb-0" *ngFor="let pic of field?.customUploadedFiles">
                                {{field.name}}: <span>{{pic?.name}}</span>
                            </p>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Picture'">
                        <div *ngIf="field.customUploadedFiles && field.customUploadedFile?.length> 0">
                            <p class="p-mb-0" *ngFor="let pic of field.customUploadedFiles">
                                {{field.name}}: <span>{{pic?.name}}</span>
                            </p>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'RadioButton'">
                        <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Rating'">
                        <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'ToggleButton'">
                        <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'DatePicker'">
                        <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                    </ng-container>
                </ng-container>
            </ng-container>
        </div>

        <div class="p-field p-formgrid p-grid" *ngIf="purchase_other1?.length>0">
            <ng-container *ngFor="let field of purchase_other1; let i=index;">
                <div class="p-col" *ngIf="purchase_other1?.length>0">
                    <div class="card">
                        <!-- Custom -->
                        <ng-container [ngSwitch]="field.formControl.name">
                            <ng-container *ngSwitchCase="'InputBox'">
                                <p class="p-mb-0">{{field.name}} <span>{{field.value}}</span></p>
                            </ng-container>
                            <ng-container *ngSwitchCase="'DropDownList'">
                                <p class="p-mb-0">{{field.name}} <span>{{field?.value?.name}}</span></p>
                            </ng-container>
                            <ng-container *ngSwitchCase="'MultipleDropDownList'">
                                <p class="p-mb-0">{{field.name}} <span>{{field?.value?.name}}</span></p>
                            </ng-container>
                            <ng-container *ngSwitchCase="'CheckBox'">
                                <p>{{field.name}} <span>{{field?.value && field?.value.length >0? field?.value[0]:
                                        ""}}</span></p>
                            </ng-container>
                            <ng-container *ngSwitchCase="'FileUpload'">
                                <div *ngIf="field.customUploadedFiles && field.customUploadedFiles?.length> 0">
                                    <p class="p-mb-0" *ngFor="let pic of field.customUploadedFiles">
                                        {{field.name}}: <span>{{pic?.name}}</span>
                                    </p>
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Picture'">
                                <div *ngIf="field.customUploadedFiles && field.customUploadedFiles?.length> 0">
                                    <p class="p-mb-0" *ngFor="let pic of field.customUploadedFiles">
                                        {{field.name}}: <span>{{pic?.name}}</span>
                                    </p>
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'RadioButton'">
                                <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Rating'">
                                <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                            </ng-container>
                            <ng-container *ngSwitchCase="'ToggleButton'">
                                <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                            </ng-container>
                            <ng-container *ngSwitchCase="'DatePicker'">
                                <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

        </div>

        <div class="card" *ngIf="purchase_other2?.length>0">
            <!-- Custom -->
            <ng-container *ngFor="let field of purchase_other2; let i=index;">
                <ng-container [ngSwitch]="field.formControl.name">
                    <ng-container *ngSwitchCase="'InputBox'">
                        <p class="p-mb-0">{{field.name}} <span>{{field.value}}</span></p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'DropDownList'">
                        <p class="p-mb-0">{{field.name}} <span>{{field?.value?.name}}</span></p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'MultipleDropDownList'">
                        <p class="p-mb-0">{{field.name}} <span>{{field?.value?.name}}</span></p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'CheckBox'">
                        <p>{{field.name}} <span>{{field?.value && field?.value.length >0? field?.value[0]:
                                ""}}</span></p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'FileUpload'">
                        <div *ngIf="field.customUploadedFiles && field.customUploadedFiles?.length> 0">
                            <p class="p-mb-0" *ngFor="let pic of field.customUploadedFiles">
                                {{field.name}}: <span>{{pic?.name}}</span>
                            </p>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Picture'">
                        <div *ngIf="field.customUploadedFiles && field.customUploadedFiles?.length> 0">
                            <p class="p-mb-0" *ngFor="let pic of field.customUploadedFiles">
                                {{field.name}}: <span>{{pic?.name}}</span>
                            </p>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'RadioButton'">
                        <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Rating'">
                        <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'ToggleButton'">
                        <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'DatePicker'">
                        <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                    </ng-container>
                </ng-container>
            </ng-container>
        </div>

        <div class="card" *ngIf="purchase_other3?.length>0">
            <!-- Custom -->
            <ng-container *ngFor="let field of purchase_other3; let i=index;">
                <ng-container [ngSwitch]="field.formControl.name">
                    <ng-container *ngSwitchCase="'InputBox'">
                        <p class="p-mb-0">{{field.name}} <span>{{field.value}}</span></p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'DropDownList'">
                        <p class="p-mb-0">{{field.name}} <span>{{field?.value?.name}}</span></p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'MultipleDropDownList'">
                        <p class="p-mb-0">{{field.name}} <span>{{field?.value?.name}}</span></p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'CheckBox'">
                        <p>{{field.name}} <span>{{field?.value && field?.value.length >0? field?.value[0]:
                                ""}}</span></p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'FileUpload'">
                        <div *ngIf="field.customUploadedFiles && field.customUploadedFiles?.length> 0">
                            <p class="p-mb-0" *ngFor="let pic of field.customUploadedFiles">
                                {{field.name}}: <span>{{pic?.name}}</span>
                            </p>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Picture'">
                        <div *ngIf="field.customUploadedFiles && field.customUploadedFiles?.length> 0">
                            <p class="p-mb-0" *ngFor="let pic of field.customUploadedFiles">
                                {{field.name}}: <span>{{pic?.name}}</span>
                            </p>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'RadioButton'">
                        <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Rating'">
                        <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'ToggleButton'">
                        <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'DatePicker'">
                        <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <p class="p-mb-0">{{field.name}} <span>{{field?.value}}</span></p>
                    </ng-container>
                </ng-container>
            </ng-container>
        </div>
    </p-tabPanel>
    <p-tabPanel header="Impacts on G/L">
        <app-inventory-impacts-gl [selectedId]="poId" [objectTypeId]="transactionTypeIds.PurchaseOrder"
            [callApi]="glApiCall"></app-inventory-impacts-gl>
    </p-tabPanel>
</p-tabView>